const feedback = {
  feedback: {
    buttonLabel: 'Feedback',
    title: 'Share Your Experience',
    subtitle: 'Help us improve your experience',
    questions: {
      overall: 'How would you rate your overall experience?',
      easeOfUse: 'How easy was it to navigate the website?',
      design: 'How would you rate the website design?',
      recommend: 'Would you recommend this website to others?',
      improvements: 'What would you like us to improve?',
      additional: 'Any additional comments or suggestions?',
    },
    placeholders: {
      improvements: 'Share your suggestions for improvements...',
      additional: 'Feel free to share any other thoughts...',
    },
    options: {
      yes: 'Yes',
      no: 'No',
    },
    validation: {
      ratingRequired: 'Please provide at least the overall rating.',
    },
    submit: 'Submit Feedback',
    submitting: 'Sending...',
    success: {
      title: 'Thank You!',
      message: 'Your feedback has been submitted successfully. We appreciate your input!',
    },
    error: 'Failed to submit feedback. Please try again.',
    privacy: 'Your feedback helps us improve. We value your privacy.',
  },
};

export default feedback;
